// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import React from "react";
import { Models } from "@hex-insights/app-modules";
import { Contract, ContractUpdateInput, ContractUpdateMutation } from "../../../Utilities";
import { ContractFormValues, ContractMutation } from "../../FormUtilities";

export type ContractUpdateButtonProps<K extends keyof ContractFormValues.Detail = keyof ContractFormValues.Detail> = {
	instanceID: Contract["id"];
	input: ContractUpdateInput;
	initialFormValues: ContractFormValues.DetailSubset<K>;
} & Omit<Models.ActionButtonProps<ContractUpdateMutation["updateContract"]>, "performAction">;

/**
 * Update button for the Contract model.
 */
export function ContractUpdateButton<K extends keyof ContractFormValues.Detail = keyof ContractFormValues.Detail>({
	instanceID,
	input,
	initialFormValues,
	...props
}: ContractUpdateButtonProps<K>) {
	const update = ContractMutation.useDirectUpdate<K>(instanceID);
	const applyUpdate = React.useCallback(async () => {
		return update(input, initialFormValues);
	}, [update, input, initialFormValues]);

	return <Models.ActionButton performAction={applyUpdate} {...props} />;
}

export type ContractUpdateButtonWithConfirmationProps<
	K extends keyof ContractFormValues.Detail = keyof ContractFormValues.Detail,
> = {
	instanceID: Contract["id"];
	input: ContractUpdateInput;
	initialFormValues: ContractFormValues.DetailSubset<K>;
} & Omit<Models.ActionButtonWithConfirmationProps<ContractUpdateMutation["updateContract"]>, "performAction">;

/**
 * Update button with confirmation for the Contract model.
 */
export function ContractUpdateButtonWithConfirmation<
	K extends keyof ContractFormValues.Detail = keyof ContractFormValues.Detail,
>({ instanceID, input, initialFormValues, ...props }: ContractUpdateButtonWithConfirmationProps<K>) {
	const update = ContractMutation.useDirectUpdate<K>(instanceID);
	const applyUpdate = React.useCallback(async () => {
		return update(input, initialFormValues);
	}, [update, input, initialFormValues]);

	return <Models.ActionButtonWithConfirmation performAction={applyUpdate} {...props} />;
}
